const ClientDetails = ({
  address = "-",
  membership = "-",
  name,
  email = "-",
  phone,
}: {
  address?: string;
  membership?: string;
  name: string;
  email?: string;
  phone?: number;
  gender?: number;
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 bg-[#F5F6FA] rounded-[10px] py-[18px] px-6">
      <DetailCell label={"Name:"} value={name} />
      <DetailCell label={"Membership:"} value={membership} />
      <DetailCell label={"Phone:"} value={phone?.toString() ?? "-"} />
      <DetailCell label={"Email:"} value={email} />
      <DetailCell label={"Address:"} value={address} />
    </div>
  );
};

export default ClientDetails;

const DetailCell = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="flex flex-nowrap gap-2 text-16px">
      <span className="font-semibold">{label}</span>
      <div>{value}</div>
    </div>
  );
};
